module.exports = __webpack_public_path__ + "static/media/pickup_button.7a9a55c8.svg";